import React from "react";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from "react-router-dom";
import { BiChevronRight } from "react-icons/bi";
import { BiChevronLeft } from "react-icons/bi";
import IndustryTable from "./industriesTable/IndustriesTable";
import { Pagination } from "antd";

function ListIndustries({ data, ListIndustriesData, onChangeVal, initialVlue, handleChange, reset }) {
  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>INDUSTRIES</h5>
          </div>
          <div className="addNew">
            <Link to="/admin/create-industry" className="btn btn-success">
              <AiOutlinePlus /> Add New Industry
            </Link>
          </div>
        </div>

        <div className="pageBody">
          <IndustryTable title="Industry" placeholder="Industry" data={data} ListIndustriesData={ListIndustriesData} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
        </div>

        <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>Showing {data?.totalCount} entries</p>
              </div>
            </div>
            <div className="col-md-6">
              <Pagination
                defaultCurrent={1}
                onChange={onChangeVal}
                total={data?.totalCount}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ListIndustries;
